import React__default, { useState } from 'react';
import { useFolderTree, useFolderSearch } from '@keepeek/commons';
import { Box, LinearProgress } from '@mui/material';
import clsx from 'clsx';
import FilterFolder from '../index.js';
import DefaultIcon from '../../../DefaultIcon/index.js';

/**
 * KFFilterFolderWrapper component.
 *
 * This component is responsible for wrapping the FilterFolder component and managing folder navigation.
 * It uses the `useFolderSearch` hook to fetch folder data and handles navigation between parent and child folders.
 *
 * @component
 * @param {KFFilterFolderWrapperProps} props - The props for the component.
 * @param {KpkFolder} [props.currentFolder] - The current folder being displayed.
 * @param {boolean} [props.showElementCount=true] - Flag to show the count of elements in the folder.
 * @param {function} props.onNavigate - Callback function to handle navigation to a folder.
 * @param {function} props.onSelectFolder - Callback function to handle folder selection.
 */
var KFFilterFolderWrapper = function (_a) {
    var _b;
    var currentFolder = _a.currentFolder, _c = _a.showElementCount, showElementCount = _c === void 0 ? true : _c, onNavigate = _a.onNavigate, onSelectFolder = _a.onSelectFolder, selectedFolder = _a.selectedFolder, isFolderListVisible = _a.isFolderListVisible, foldersAuthorized = _a.foldersAuthorized, _d = _a.KIcon, KIcon = _d === void 0 ? DefaultIcon : _d, _e = _a.testId, testId = _e === void 0 ? "KFFilterFolderWrapper" : _e, className = _a.className, _f = _a.id, id = _f === void 0 ? "KFFilterFolderWrapper" : _f, style = _a.style, sx = _a.sx;
    var _g = useFolderTree({
        folderId: currentFolder ? currentFolder.id : undefined,
        rootFolderIds: foldersAuthorized,
        countMedias: showElementCount
    }), folderTree = _g.folderTree, loadingFolders = _g.loading;
    var folderTreesParents = useFolderSearch({
        folderIds: (folderTree === null || folderTree === void 0 ? void 0 : folderTree.folder.parentFolderId) ? [folderTree === null || folderTree === void 0 ? void 0 : folderTree.folder.parentFolderId] : [],
        withChildrenList: false,
        countMedias: false
    }).folderTrees;
    var parentKpkFolder;
    if (folderTreesParents && folderTreesParents.length === 1) {
        parentKpkFolder = folderTreesParents[0].folder;
    }
    var _h = useState(true), navigationDown = _h[0], setNavigationDown = _h[1];
    var onGoToChildren = function (folder) {
        onNavigate(folder);
        setNavigationDown(true);
    };
    var onGoToParent = function () {
        onNavigate(parentKpkFolder);
        setNavigationDown(false);
    };
    return (React__default.createElement(Box, { className: clsx("KFFilterFolderWrapper", className), "data-testid": testId, id: id, style: style, sx: sx },
        loadingFolders && (React__default.createElement(Box, { sx: { position: "relative" } },
            React__default.createElement(LinearProgress, { sx: { position: "absolute", width: "100%" } }))),
        React__default.createElement(FilterFolder, { folderList: (_b = folderTree === null || folderTree === void 0 ? void 0 : folderTree.children) !== null && _b !== void 0 ? _b : [], onSelectFolder: onSelectFolder, onGoToParent: onGoToParent, onGoToChildren: onGoToChildren, showElementCount: showElementCount, currentFolder: (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.title) ? currentFolder : (currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.id) ? folderTree === null || folderTree === void 0 ? void 0 : folderTree.folder : undefined, parentFolder: parentKpkFolder, KIcon: KIcon, selectedFolder: (selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.title)
                ? selectedFolder
                : (selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.id)
                    ? folderTree === null || folderTree === void 0 ? void 0 : folderTree.folder
                    : undefined, isFolderListVisible: isFolderListVisible, loadingFolders: loadingFolders, navigationDown: navigationDown })));
};

export { KFFilterFolderWrapper as default };
//# sourceMappingURL=index.js.map
